export const customParamsHitSearchScope = [
  'unlocked_eligibility',
  'searches',
  'discount_card',
  'ticket_type',
  'trip_type',
  'trip_dates',
  'location',
  'class_type',
  'hotel_dates',
  'trip_distance',
  'arrival_city_code',
  'departure_city_code',
  'transaction_price',
  'carrier_trip_number',
  'selection_type',
  'provider_product',
  'low_co2',
  'buypath',
  'dynamic_funnel',
] as const;

export const customParamsHitFlowScope = [
  'provider',
  'bundle_ID',
  'booking_status',
  'page_category',
  'booking_id',
  'bf_sb_id',
  'smart_funnel_productstoskip',
  'product_frozen',
  'products_linked',
] as const;

export const customParamsHitScope = [
  ...customParamsHitSearchScope,
  ...customParamsHitFlowScope,
  'site_type',
  'release_number',
  'mkttrack',
  'mktsession_id',
  'r_marketing_split',
  'app_traffic',
  'wapbx_exp',
  'connection_type',
  'touchpoint',
  'url',
  'car_price_split',
  'full_referrer',
  'misc',
  'checked_booking_id',
  'subscription_type',
  'subscription_prime_mode',
  'subscription_group',
  'subscription_permitted',
  'mid_token',
  'beta',
  'hit_type',
  'sso_hit',
  'screen_name',
  'affiliation',
  'coupon',
  'event_action',
  'event_category',
  'event_label',
  'edo_campaign_code',
] as const;

export const customMetrics = [
  'number_of_passengers',
  'number_of_adults',
  'number_of_children',
  'number_of_infants',
  'duration',
  'number_of_rooms_in_dp',
  'days_in_advanced',
  'gross_sale',
] as const;

export const customParamsProduct = [
  'departure_date',
  'arrival_date',
  'payment_method',
  'product_code',
  'transport_code',
] as const;
